import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

import { BaseHttpService } from '@framework/services';

@Injectable()
export class VttHttpService extends BaseHttpService {
  constructor(httpClient: HttpClient) {
    // API base path for VTTs under a company
    super(httpClient, '/companies');
  }

  /** Load all VTT files for a company */
  public load(companyId: number,asset_id:any) {
    return this.get(`/${companyId}/vtt/${asset_id}/`).pipe(
      map((response: any) => response)
    );
  }

  /** Add a new VTT file */
  public add(companyId: number, asset_id,payload: any) {
    return this.post(`/${companyId}/vtt/${asset_id}/`, payload).pipe(
      map((response: any) => response)
    );
  }

  /** Update an existing VTT file */
  public update(companyId: number, asset_id: any, payload: any) {
    return this.put(`/${companyId}/vtt/${asset_id}/${payload.track_id}`, payload).pipe(
      map((response: any) => response)
    );
  }

  /** Delete a VTT file */
  public deletevtt(companyId: number, asset_id: any, track_id:any) {
    return this.delete(`/${companyId}/vtt/${asset_id}/${track_id}`).pipe(
      map((response: any) => response)
    );
  }
}
